module.exports = __webpack_public_path__ + "static/media/image3.572bb4a4.png";